import { Message } from 'view-design'

function showInfoMsg(message) {
    Message.info(message);
}

function showSuccessMsg(message) {
    Message.success(message);
}

function showWarningMsg(message) {
    Message.warning(message);
}

function showErrorMsg(message) {
    Message.error(message);
}


var xuanzhuanTimer = null;

function refreshXuanZhuan(document) {
    document.getElementById("refresh").classList.add("xuanzhuan");

    if (xuanzhuanTimer) {
        clearTimeout(xuanzhuanTimer);
    }
    
    xuanzhuanTimer = setTimeout(() => {
        document.getElementById("refresh").classList.remove("xuanzhuan");
        xuanzhuanTimer = null;
    }, 2000);
}

export default {
    showInfoMsg, showSuccessMsg, showWarningMsg, showErrorMsg, refreshXuanZhuan
}


// WEBPACK FOOTER //
// ./src/utils/uiUtils.js